import { render, staticRenderFns } from "./TagListFeature.vue?vue&type=template&id=0af7ee70&scoped=true&"
import script from "./TagListFeature.vue?vue&type=script&lang=js&"
export * from "./TagListFeature.vue?vue&type=script&lang=js&"
import style0 from "./TagListFeature.vue?vue&type=style&index=0&id=0af7ee70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7ee70",
  null
  
)

export default component.exports